var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylContactJoinUsMobile'):_c('ylContactJoinUsPC')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }